import React, { useEffect, useRef, useState } from 'react';
import { archivePolicy, fetchAllHomePolicies, getAllBranchStaffById, getAllCompanyStaffById, getAllFleetPolicies, getAllPolicies } from '../../../../api/requests';
import GTable from '../../../../components/elements/GTable';
import Page from '../../../../components/PageWrapper';
import { Policy } from '../../../../models/policy/Policy';
import {
  getFormattedAccessRight, getInstallmentTypeFromKey, getPhoneNumberFromShortCodeFormat, getPolicyReviewStatus,
  getVehicleProtectionFromKey, getVehicleUsageFromKey, formatCurrencyAmount,
  getOrUpdateQueriesFromUrl,
  updateQueriesList,
  onRemoveFilter,
  showToast,
  capitalizeSentence
} from '../../../../utils/miscFunctions';
import moment from 'moment';
import clsx from 'clsx';
import { COMPANY_TYPES, CUSTOMER_TYPE, POLICY_REVIEW_STATES, POLICY_TYPES } from '../../../../resources/enums';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PopOnMe from '../../../../components/elements/poponme';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import useUserAccount from '../../../../hooks/userAccountHook';
import useRoute from '../../../../hooks/routesHook';
import usePolicy from '../../../../hooks/policyHook';
import useModal from '../../../../hooks/modalHook';
import { IRequestResponse, ITableFilterItem } from '../../../../resources/interfaces';
import PolicyStatus from '../../../../components/elements/PolicyStatus';
import BulkUploadBadge from '../../../../components/elements/BulkUploadBadge';
import IndeterminateCheckbox from '../../../../components/elements/IndeterminateCheckbox';
import { HomePolicy } from '../../../../models/homePolicy/HomePolicy';
import { IHomePolicy } from '../../../../models/homePolicy/IHomePolicy';
import TableFilter from '../../../../components/elements/GTable/InGTableComponents/TableFilter/index';
import TableFilterForm from '../../../../components/elements/GTable/InGTableComponents/TableFilter/TableFilterForm';
import { VEHICLE_PROTECTION_TYPES, VEHICLE_USAGES } from '../../../../resources/constants';
import useDownload from '../../../../hooks/downloadHook';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useLayoutHook from '../../../../hooks/layoutHook';
import TabNav, { ITab } from '../../../../components/tabs/TabNav';
import TabContent from '../../../../components/tabs/TabContent';
import { TbClipboardCopy } from "react-icons/tb";
import { FaLink } from "react-icons/fa6";
import { LuExternalLink } from "react-icons/lu";
import IconAction from '../../../../components/elements/GTable/InGTableComponents/IconAction';
import { getSelectedCountry } from '../../../../states/slices/resourceSlice';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import { PolicySummary } from '../../../../models/policy/PolicySummary';
import { Archive, Ban, CheckCircle, ChevronDown, Clock, CreditCard, Download, Edit, Eye, FileDown, FileInput, FilePlus, FileUp, Plus, RotateCw, Trash, Upload, UserPlus } from 'lucide-react';
import usePartner from '../../../../hooks/partnerHook';
import { Company } from '../../../../models/company/Company';
import { getAllInsurers } from '../../../../services/insurer';
import { MdChangeCircle } from 'react-icons/md';
import { useTableFilters } from '../../../../hooks/useTableFilters';
import Tooltip from '../../../../components/ToolTip';
import RouteLink from '../../../../components/elements/GTable/InGTableComponents/RouteLink';
import useBranch from '../../../../hooks/branchHook';
import useLeads from '../../../../hooks/leadsHook';
import { GTableActionColumn, ITablePaginationData, ITableRowAction } from '../../../../components/elements/GTable/GTable';
import Banner from '../../../../components/ui/Banner';
import Button from '../../../../components/form-control/Button';
import QuoteWidgetCalculator from '../../../admin/quotes/calculators/widgetChecker/components/Calculator';
import ShowPendingInfo from '../../../../components/elements/ShowPendingInfo';

function Policies(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const { user } = useUserAccount();
  const companyId = user?.company?.id;
  const userBranchId = user?.branch?.id;
  const { POLICY_FILTERS, renewMotorPolicy, policiesCount, PolicyModalComponent, assignPoliciesToCommunity, exportFilteredPolicies, setPolicyToDueLater, assignPolicyToBroker, handleDeletePolicyByNumber, showDownloadPolicyDetailsModal, fleetColumns, homeColumns,
    provideMomoDetails, archiveAPolicy } = usePolicy();
  const { fetchAllCompaniesByType } = usePartner();
  const { getDashboardBase } = useRoute();
  const navigate = useNavigate();
  const { updateModalStates, ModalComponent, closeModal } = useModal();
  const { screenWidth } = useLayoutHook();
  const location = useLocation();
  const [brokers, setBrokers] = useState<{ name: string; value: number }[]>([]);
  const [fleetPolicies, setFleetPolicies] = useState<any[]>([]);
  const [homePolicies, setHomePolicies] = useState<any>([]);
  const [selectedPolicies, setSelectedPolicies] = useState<any>([]);
  const [selectedPoliciesIndexes, setSelectedPoliciesIndexes] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [renewalLoading, setRenewalLoading] = useState<boolean>(true);
  const [searchString, setSearchString] = useState<string>();
  const [showPerPage, setShowPerPage] = useState<number>(25);
  const [networkError, setNetworkError] = useState<boolean>(false)
  const [filter, setFilter] = useState<POLICY_REVIEW_STATES | 'Individual' | undefined>(getInitFilters());
  const currentPage = Number(searchParams.get("page")) || 0;
  const [admins, setAdmins] = useState<any[]>([]);
  const [branchStaffs, setBranchStaffs] = useState<any[]>([])
  const [insurers, setInsurers] = useState<any>([]);
  const pageRef = useRef<HTMLDivElement>(null)
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const { showAdminDownloadAllPoliciesModal, DownloadHookModal } = useDownload();
  const { getBranchlist } = useBranch();
  const { getLeadSourceFilters } = useLeads()

  const {
    filters: tableFilters,
    setFilters,
    getFilterValue,
  } = useTableFilters({
    initialFilters: [],
    syncWithUrl: true,
  });

  const { data: branches } = useQuery({
    queryKey: ['getBranchlist'],
    queryFn: async () => {
      const response: any = await getBranchlist(0, 100, true);
      const _branches = response?.map((branch: Pick<Company, 'id' | 'name'>) => ({
        name: branch.name,
        value: Number(branch.id)
      }));
      return (_branches);
    }
  })

  const [policiesFleetPaginationData, setPoliciesFleetPaginationData] = useState<ITablePaginationData>({
    total: 0,
    per_page: 0,
    totalPages: 0,
    initialPage: currentPage ? currentPage : 0,
    to: 0,
    from: 0
  });

  const [homePoliciesPaginationData, setHomePoliciesPaginationData] = useState<ITablePaginationData>({
    total: 0,
    per_page: 0,
    totalPages: 0,
    initialPage: currentPage ? currentPage : 0,
    to: 0,
    from: 0
  });

  const queriesList: Record<string, string> = {
    type: 'motor',
    page: String(currentPage)
  }

  const queriesName = [
    'insurer',
    'broker',
    'manager',
    'park',
    'lead_source',
    'vehicle_usage',
    'protection_type',
    'review_stage'
  ]

  const getTypeFromRoute = () => {
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type');

    return type ?? POLICY_TYPES.AUTO;
  };

  const policyType = getTypeFromRoute();
  const [activeTab, setActiveTab] = useState<string>(searchParams.get('tab') ? String(searchParams.get('tab')) : 'individual');
  const queryClient = useQueryClient();
  const baseUrl = window.location.origin;
  const selectedCountry = useSelector(getSelectedCountry);
  const countryId = selectedCountry?.id ?? 1

  useEffect(() => {
    setFilters(getDefaultFilters());
  }, [admins, insurers, brokers]);

  useEffect(() => {
    scrollToTop()
  }, [currentPage])

  const getTabs = () => {
    let tabs: ITab[] = [
      {
        id: 'individual',
        title: 'Individual'
      },
      {
        id: 'fleet',
        title: 'Fleet'
      }
    ];

    return tabs;
  };

  function getDefaultFilters() {
    const filters: ITableFilterItem[] = [
      {
        name: 'protection_type',
        value: searchParams.get('protection_type') ? String(searchParams.get('protection_type')) : '',
        type: 'select',
        list: getVehicleProtectionTypeFilters(),
        placeholder: 'Select protection type',
        label: 'Protection type'
      },
      {
        name: 'review_stage',
        value: searchParams.get('review_stage') ? String(searchParams.get('review_stage')) : '',
        type: 'select',
        list: POLICY_FILTERS,
        placeholder: 'Select status',
        label: 'Status'
      },
      {
        name: 'vehicle_usage',
        value: searchParams.get('vehicle_usage') ? String(searchParams.get('vehicle_usage')) : '',
        type: 'select',
        list: getVehicleUsageFilters(),
        placeholder: 'Select vehicle usage',
        label: 'Vehicle usage'
      },
      {
        name: 'create_date',
        value: '',
        value2: '',
        type: 'dateRange',
        placeholder: 'Select start date',
        label: 'Created date'
      },
      {
        name: 'expiry_date',
        value: '',
        type: 'dateRange',
        placeholder: 'Select expiry date',
        label: 'Expiry date'
      },
      {
        name: 'inception_date',
        value: '',
        type: 'dateRange',
        placeholder: 'Select inception date',
        label: 'Inception date'
      }
    ];

    if (!user.isInsurer()) {
      filters.unshift(
        {
          name: 'insurer',
          value: searchParams.get('insurer') ? String(searchParams.get('insurer')) : '',
          value2: searchParams.get('insurer') ? String(searchParams.get('insurer')) : '',
          type: 'select',
          list: insurers,
          placeholder: 'Select insurer',
          label: 'Insurer',
          showSearch: true
        }
      );
    }

    if (!(user.isInsurer() || user.isAdministrator() || user.isAgent())) {
      filters.unshift(
        {
          name: 'manager',
          value: searchParams.get('manager') ? String(searchParams.get('manager')) : '',
          value2: searchParams.get('manager') ? String(searchParams.get('manager')) : '',
          type: 'select',
          list: admins,
          placeholder: `Select policy manager`,
          label: `Policy manager`
        },
      );
    }

    if (!user?.isBroker()) {
      filters.unshift({
        name: 'broker',
        value: searchParams.get('broker') ? String(searchParams.get('broker')) : '',
        value2: searchParams.get('broker') ? String(searchParams.get('broker')) : '',
        type: 'select',
        list: brokers,
        placeholder: 'Select broker',
        label: 'Broker',
        showSearch: true
      },
      )
    }

    if (user.isInternalAdmin()) {
      filters?.push({
        name: 'lead_source',
        value: searchParams.get('lead_source') ? String(searchParams.get('lead_source')) : '',
        type: 'select',
        list: getLeadSourceFilters(),
        placeholder: 'Select lead source',
        label: 'Signup source'
      },
      )
    }
    if (user.isInternalAdmin() || user?.isSupervisor() || user?.isOwner()) {
      filters?.push({
        name: 'branchId',
        value: searchParams.get('branchId') ? String(searchParams.get('branchId')) : '',
        type: 'select',
        list: branches,
        placeholder: 'Select branch',
        label: 'Branch'
      },
      )
    }
    return filters;
  }

  const getAllAdmins = () => {
    companyId && getAllCompanyStaffById(Number(companyId))
      .then((response: any) => {
        const _admins = response.filter((admin: any) => admin.activated === true)?.map((admin: any) => ({
          name: `${admin.name}`,
          value: admin.id,
        }));
        setAdmins(_admins);
      })
      .catch(() => { });
  };

  const getAllBranchStaffs = () => {
    userBranchId && getAllBranchStaffById(Number(userBranchId))
      .then((response: any) => {
        const _staffs = response?.map((staff: any) => ({
          name: `${staff.fullName} (${getFormattedAccessRight(
            staff.role.accessRight
          )})`,
          value: staff.id,
        }))
        setBranchStaffs(_staffs);
      })
      .catch(() => { });
  };

  const getAllBrollyInsurers = () => {
    getAllInsurers(countryId)
      .then((response: any) => {
        const allInsurers = response?.data?.map((insurer: any) => ({
          name: `${insurer.name}`,
          value: Number(insurer.id)
        }));
        setInsurers(allInsurers);
      })
      .catch(() => { })
  };

  const { mutate: exportPoliciesFromFilters } = useMutation({
    mutationFn: (): any => {
      return exportFilteredPolicies(
        _filter,
        searchParam,
        expiredFrom,
        expiredTo,
        createFrom,
        createTo,
        startFrom,
        startTo,
        protectionType,
        vehicleUsage,
        leadSource,
        managerId,
        insurerId,
        branchId
      );
    },
  })

  function getInitFilters(): POLICY_REVIEW_STATES | 'Individual' {
    switch (searchParams.get('filter')?.toLowerCase()) {
      case 'in_approval':
        return POLICY_REVIEW_STATES.IN_APPROVAL;

      case 'approved':
        return POLICY_REVIEW_STATES.APPROVED;

      case 'in_review':
        return POLICY_REVIEW_STATES.IN_REVIEW;

      case 'new':
        return POLICY_REVIEW_STATES.NEW;

      case 'declined':
        return POLICY_REVIEW_STATES.DECLINED;

      case 'cancelled':
        return POLICY_REVIEW_STATES.CANCELLED;

      case 'expired':
        return POLICY_REVIEW_STATES.EXPIRED;

      case 'archived':
        return POLICY_REVIEW_STATES.ARCHIVED;

      case 'due_later':
        return POLICY_REVIEW_STATES.DUE_LATER;

      default:
        return 'Individual';
    }
  }

  function getVehicleUsageFilters() {
    const usage: any = [];

    for (const key in VEHICLE_USAGES) {
      if (Object.prototype.hasOwnProperty.call(VEHICLE_USAGES, key)) {
        usage.push({
          name: getVehicleUsageFromKey(key)?.title,
          value: key
        });
      }
    }

    return usage;
  }

  function getVehicleProtectionTypeFilters() {
    const type: any = [];

    for (const key in VEHICLE_PROTECTION_TYPES) {
      if (Object.prototype.hasOwnProperty.call(VEHICLE_PROTECTION_TYPES, key)) {
        type.push({
          name: getVehicleProtectionFromKey(key)?.title,
          value: key
        });
      }
    }

    return type;
  }

  const searchParam = searchString;
  const inceptionDateFilter = getFilterValue('inception_date') || {};
  const startFrom = inceptionDateFilter?.from;
  const startTo = inceptionDateFilter?.to;
  const expiryDateFilter = getFilterValue('expiry_date') || {};
  const expiredTo = expiryDateFilter?.to;
  const expiredFrom = expiryDateFilter?.from;
  const createDateFilter = getFilterValue('create_date') || {};
  const createTo = createDateFilter?.to;
  const createFrom = createDateFilter?.from;
  const protectionType = searchParams.get('protection_type') ? searchParams.get('protection_type') : getFilterValue('protection_type');
  const vehicleUsage = searchParams.get('vehicle_usage') ? searchParams.get('vehicle_usage') : getFilterValue('vehicle_usage');
  const leadSource = searchParams.get('lead_source') ? searchParams.get('lead_source') : getFilterValue('lead_source');
  const managerId = searchParams.get('manager') ? searchParams.get('manager') : getFilterValue('manager');
  const park = searchParams.get('park') ? searchParams.get('park') : getFilterValue('park');
  const _filter = searchParams.get('review_stage') ? searchParams.get('review_stage') : getFilterValue('review_stage');
  const insurerId = searchParams.get('insurer') ? searchParams.get('insurer') : getFilterValue('insurer');
  const brokerId = searchParams.get('broker') ? searchParams.get('broker') : getFilterValue('broker');
  const branchId = searchParams.get('branchId') ? searchParams.get('branchId') : getFilterValue('branchId');

  const getPolicies = async () => {
    const page = currentPage;
    if (policyType === POLICY_TYPES.AUTO && activeTab === 'individual' && countryId) {
      return await getAllPolicies(
        page,
        showPerPage,
        countryId,
        searchParam,
        _filter === 'Individual' ? undefined : _filter,
        expiredFrom,
        expiredTo,
        createFrom,
        createTo,
        startFrom,
        startTo,
        protectionType,
        vehicleUsage,
        leadSource,
        managerId,
        brokerId,
        insurerId,
        branchId,
      )
        .then((response: any) => {

          return response

        })
        .catch((error: IRequestResponse) => {
          console.log(error.description || error.message);
          setNetworkError(true)
        })
        .finally(() => {
          setLoading(false);
        });
    }

    if (policyType === POLICY_TYPES.HOME) {
      getHomePolicies();
    }
  };

  const scrollToTop = () => {
    if (pageRef.current) {
      pageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // const getFleetPolicies = () => {
  //   const page = currentPage;
  //   if (policyType === POLICY_TYPES.AUTO && activeTab === 'fleet') {
  //     getAllFleetPolicies(
  //       page,
  //       showPerPage,
  //       searchParam,
  //       _filter === 'Individual' ? undefined : _filter,
  //       expiredFrom,
  //       expiredTo,
  //       createFrom,
  //       createTo,
  //       startFrom,
  //       startTo,
  //       managerId,
  //       park,
  //     )
  //       .then((response: any) => {
  //         const fleets = response?.content
  //         setFleetPolicies(fleets);


  //         const from = response.pageable?.offset + 1;
  //         const to =
  //           from + response.size > response.totalElements
  //             ? response.totalElements
  //             : from + response.size - 1;

  //         setPoliciesFleetPaginationData({
  //           ...policiesFleetPaginationData,
  //           ...{
  //             per_page: response.size,
  //             total: response.totalElements,
  //             totalPages: response.totalPages,
  //             from: from,
  //             to: to
  //           }
  //         });
  //       })
  //       .catch((error: Error) => {
  //         showToast.error(error.name, error.message);
  //         setNetworkError(true)
  //       })
  //       .finally(() => {
  //         setRenewalLoading(false);
  //       });
  //   }
  // };

  const getHomePolicies = (page = currentPage) => {
    fetchAllHomePolicies(page, showPerPage)
      .then((response: any) => {
        const _homePolicies = response?.content?.map((_homePolicy: IHomePolicy) => {
          return new HomePolicy(_homePolicy);
        });

        setHomePolicies(_homePolicies);
        const from = response.pageable?.offset + 1;
        const to =
          from + response.size > response.totalElements
            ? response.totalElements
            : from + response.size - 1;

        setHomePoliciesPaginationData({
          ...homePoliciesPaginationData,
          ...{
            per_page: response.size,
            total: response.totalElements,
            totalPages: response.totalPages,
            from: from,
            to: to
          }
        });
      })
      .catch((error: IRequestResponse) => {
        showToast.error(error.description || error.message);
        setNetworkError(true)
      });
  };

  const getTableRowActions = (data: Policy): ITableRowAction[] => {
    const actions = [
      {
        label: 'View',
        icon: <Eye className='h-4 w-4' />,
        callback: (policy: Policy) => {
          navigate(`${getDashboardBase()}/policies/${policy.ref}?type=motor`, { replace: true });
        },
        data: data
      },
      {
        label: 'Download policy',
        icon: <Download className="h-4 w-4" />,
        callback: () => showDownloadPolicyDetailsModal(data?.ref),
        data: data
      },
      {
        label: 'Update policy',
        icon: <Edit className="h-4 w-4" />,
        callback: () => navigate(`${getDashboardBase()}/policies/${data?.ref}/edit?type=motor`),
        data: data
      },
    ];

    // if ((user.isAdministrator() || user.isInsurer() || user.isInsurerAdmin() || user.isSupervisor()) && !data?.isApproved()) {
    //   actions.push({
    //     label: 'Set to due later',
    //     icon: <Clock className="h-4 w-4" />,
    //     callback: (policy: Policy) => {
    //       setPolicyToDueLater(policy);
    //     },
    //     data: data
    //   });
    // }

    // if (!(user.isOwner() || user.isSupervisor()) && !data?.isApproved()) {
    //   actions.push({
    //     label: 'Edit',
    //     icon: <Edit className="h-4 w-4" />,
    //     callback: (policy: Policy) => {
    //       navigate(`${getDashboardBase()}/policies/${policy.ref}/?type=motor`, { replace: true });
    //     },
    //     data: data
    //   });
    // }

    // if (!data?.isFullPayment?.()) {
    //   actions.push({
    //     label: 'Activate recurring payment',
    //     icon: <CreditCard className='h-4 w-4' />,
    //     callback: (policy: Policy) => {
    //       provideMomoDetails(policy);
    //     },
    //     data: data
    //   });
    // }

    if (!(data?.reviewStage == 'ARCHIVED' || data?.reviewStage == 'APPROVED' || data?.active)) {
      actions.push({
        label: 'Archive',
        icon: <Archive className='h-4 w-4' />,
        callback: (policy: Policy) => {
          archiveAPolicy(policy);
        },
        data: data
      });
    }

    // if (!user.isInternalAdmin() && data?.active || data.isExpired() && activeTab !== 'fleet') {
    //   actions.push({
    //     label: 'Renew policy',
    //     icon: <RotateCw className="h-4 w-4" />,
    //     callback: () => renewMotorPolicy(data),
    //     data: data
    //   });
    // }

    // if (activeTab !== 'fleet' && (data?.insurerPolicyNumber || !(data?.insurerPolicyNumber && data?.active))) {
    //   actions.push({
    //     label: 'Delete',
    //     icon: <Trash className='h-4 w-4' />,
    //     callback: () => handleDeletePolicyByNumber(data?.ref),
    //     data: data
    //   })
    // }

    // if (user?.isInternalAdmin()) {
    //   actions.push({
    //     label: 'Assign policy to broker',
    //     icon: <MdChangeCircle className="h-4 w-4" />,
    //     callback: (policy: Policy) => {
    //       assignPolicyToBroker(policy);
    //     },
    //     data: data
    //   })
    // }

    return actions;
  };

  const columns = React.useMemo(
    () => [
      {
        id: 'selection',
        meta: {
          sticky: 'left',
          offset: -1
        },
        Header: ({ getToggleAllRowsSelectedProps }: any) => (
          <div className="">
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({ row }: any) => (
          <div className="">
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        )
      },
      {
        Header: 'M',
        columns: [
          {
            Header: 'Insurer Policy #',
            accessor: 'insurerPolicyNumber',
            meta: {
              sticky: 'left',
              offset: 40
            },
            Cell: (row: any) => {
              return (
                <RouteLink to={`${getDashboardBase()}/policies/${row?.row?.original.ref}?type=motor`}>
                  {row.cell.value ?? <ShowPendingInfo message="Missing Policy Number" classes=' !w-fit  whitespace-nowrap  h-[24px]  gap-[2px] flex items-center justify-start italic text-gray-400 text-xs rounded-full border border-gray-400 p-2'/>}
                </RouteLink>
              );
            }
          },
          // {
          //   Header: ' ',
          //   accessor: ' ',
          //   meta: {
          //     sticky: 'left',
          //     offset: 210
          //   },
          //   Cell: (row: any) => {
          //     return (
          //       <>
          //         <IconAction
          //           messageIconOne={`Copy policy ID`}
          //           IconOne={TbClipboardCopy}
          //           onclickIconOne={async () => {
          //             await navigator.clipboard.writeText(`${row?.row?.original.ref}`);
          //           }}

          //           messageIconTwo={`Copy policy link`}
          //           IconTwo={FaLink}
          //           onclickIconTwo={async () => {
          //             await navigator.clipboard.writeText(
          //               baseUrl +
          //               '/admin' +
          //               `/policies/${row?.row?.original.ref}?type=motor`
          //             );
          //           }}

          //           messageIconThree={`Open in a new tab`}
          //           IconThree={LuExternalLink}
          //           linkTo={`${getDashboardBase()}/policies/${row?.row?.original.ref
          //             }?type=motor&filter=${filter}`}
          //         />

          //       </>
          //     );
          //   }
          // },
          {
            Header: 'Customer',
            accessor: 'firstName',
            meta: {
              sticky: 'left',
              offset: 190
            },
            Cell: (row: any) => {
              const isCustomerTypeIndividual = row?.row?.original?.customerType === CUSTOMER_TYPE.INDIVIDUAL;
              const isCustomerTypeBusiness = row?.row?.original?.customerType === CUSTOMER_TYPE.BUSINESS;
              const fullName = `${row?.row?.original?.firstName} ${row?.row?.original?.lastName}`

              return (
                <RouteLink to={`${getDashboardBase()}/customers/${row.row.original?.customerId}`} showTooltip toolTipMessage={fullName} tooltipDisabled={fullName.length < 25}>
                  {capitalizeSentence(fullName)} {isCustomerTypeBusiness && ` - ${capitalizeSentence(row?.row?.original?.businessName)}`}
                </RouteLink>
                // <div className="flex items-center gap-1">
                //   <RouteLink to={`${getDashboardBase()}/customers/${row.row.original?.customerId}`} showTooltip toolTipMessage={fullName} tooltipDisabled={fullName.length < 25}>
                //     {capitalizeSentence(fullName)} {isCustomerTypeBusiness && ` - ${capitalizeSentence(row?.row?.original?.businessName)}`}
                //   </RouteLink>

                //   {isCustomerTypeIndividual ?
                //     <Tooltip message="Individual Customer" placement='bottom'>
                //       <span className="inline-flex items-center justify-center w-4 h-4 ml-1 text-xs font-bold text-blue-600  rounded-sm border border-blue-600 dark:text-yellow-600 dark:border-yellow-600">
                //         i
                //       </span>
                //     </Tooltip>
                //     : isCustomerTypeBusiness ?
                //       <Tooltip message="Business Customer" placement='bottom'>
                //         <span className="inline-flex items-center justify-center w-4 h-4 ml-1 text-xs font-bold text-blue-600  rounded-sm border border-blue-600 dark:text-yellow-600 dark:border-yellow-600">
                //           b
                //         </span>
                //       </Tooltip>
                //       : null
                //   }
                // </div>
              );
            }
          },
          ...(user?.isInternalAdmin() ? [{
            Header: 'Brolly Policy ID',
            accessor: 'ref',
            Cell: (row: any) => {
              const isFleet = row?.row?.original?.fleetPolicy;
              const isOldPolicyRenewed = row?.row?.original?.renewed && row?.row?.original?.renewedPolicyNumber;
              const isNewRenewed = row?.row?.original?.oldPolicyNumber;
              return (
                <Link to={`${getDashboardBase()}/policies/${row?.row?.original.ref}?type=motor&filter=${filter}`}>
                  <span className="hover:underline text-link-main dark:text-darkBg-textLink dark:hover:text-darkBg-textLink">
                    {row.cell.value ?? '-'}
                  </span>
                </Link>
                // <div className="flex items-center gap-1">
                //   <Link to={`${getDashboardBase()}/policies/${row?.row?.original.ref}?type=motor&filter=${filter}`}>
                //     <span className="hover:underline text-link-main dark:text-darkBg-textLink dark:hover:text-darkBg-textLink">
                //       {row.cell.value ?? '-'}
                //     </span>
                //   </Link>
                //   {isFleet && (
                //     <Tooltip message="Fleet policy" placement='bottom'>
                //       <span className="inline-flex items-center justify-center w-4 h-4 ml-1 text-xs font-bold text-blue-600  rounded-sm border border-blue-600 dark:text-yellow-600 dark:border-yellow-600">
                //         f
                //       </span>
                //     </Tooltip>
                //   )}
                //   {isOldPolicyRenewed && (
                //     <Tooltip message='Click to view renewed policy' placement='bottom'>
                //       <Link to={`${getDashboardBase()}/policies/${row?.row?.original.renewedPolicyNumber}?type=motor&filter=${filter}`} target={'_blank'}
                //         className="inline-flex items-center justify-center w-4 h-4 ml-1 text-xs font-bold text-red-600 bg-red-50 rounded-sm border border-red-600 dark:text-red-400 dark:bg-red-900/20 dark:border-red-400 transition-colors duration-200">
                //         r
                //       </Link>
                //     </Tooltip>
                //   )}
                //   {isNewRenewed && (
                //     <Tooltip message="Click to view old policy" placement='bottom'>
                //       <Link to={`${getDashboardBase()}/policies/${row?.row?.original.oldPolicyNumber}?type=motor&filter=${filter}`} target='_blank'
                //         className="inline-flex items-center justify-center w-4 h-4 ml-1 text-xs font-bold text-green-600 bg-green-50 rounded-sm border border-green-600 dark:text-green-400 dark:bg-green-900/20 dark:border-green-400 transition-colors duration-200">
                //         r
                //       </Link>
                //     </Tooltip>
                //   )}
                // </div>
              );
            }
          }] : []),
          {
            Header: 'Phone #',
            accessor: 'phone',
            Cell: (row: any) => {
              return <span>{getPhoneNumberFromShortCodeFormat(row.cell.value) ?? '-'}</span>;
            }
          },
          {
            Header: 'Status',
            accessor: 'reviewStage',
            Cell: (row: any) => {
              return (
                <PolicyStatus
                  status={getPolicyReviewStatus(row.cell.value)}
                  firstSuccessfulPayment={new Policy(
                    row?.row?.original
                  )?.isInitialPaymentReceived()}
                  classes="px-2 w-full"
                />
              );
            }
          },
          {
            Header: 'Bulk Upload',
            accessor: 'bulkImported',
            Cell: (row: any) => <BulkUploadBadge bulkImported={row.cell.value} />
          },
          // {
          //   Header: 'Status',
          //   accessor: 'active',
          //   Cell: (row: any) => {
          //     return (
          //       <div className="">
          //         {row.cell.value ? (
          //           <div className="px-2 border  border-[#0F7125] text-xs flex  h-[24px] w-fit items-center justify-center text-[#0F7125] rounded-full ">
          //             <CheckCircle className="inline-block w-4 h-4 mr-1" />Active
          //           </div>
          //         ) : (
          //           <div className=" px-2 border border-red-800 text-xs flex  h-[24px] w-fit items-center justify-center text-red-800 rounded-full ">
          //             <Ban className="inline-block w-4 h-4 mr-1" /><span>Inactive</span>
          //           </div>
          //         )}
          //       </div>
          //     );
          //   }
          // },
          {
            Header: 'Protection Type',
            accessor: 'protectionType',
            Cell: (row: any) => {
              return (
                <PolicyStatus status={getPolicyReviewStatus(row.cell.value)} classes="px-2" />
              );
            }
          },
          // {
          //   Header: 'Installment Type',
          //   accessor: 'installmentType',
          //   Cell: (row: any) => {
          //     return (
          //       row.cell.value ? <PolicyStatus status={getInstallmentTypeFromKey(row.cell.value)} classes="px-2" /> : <span>-</span>
          //     );
          //   }
          // },
          // {
          //   Header: 'Paid to insurer',
          //   accessor: 'premiumPaidToInsurer',
          //   Cell: (row: any) => {
          //     return (
          //       row.cell.value ?
          //         <div className='px-2 border  border-[#0F7125] text-xs flex  h-[24px] w-fit items-center justify-center text-[#0F7125] rounded-full'>
          //           Paid
          //         </div> :
          //         <div className='px-2 border border-red-800 text-xs flex  h-[24px] w-fit items-center justify-center text-red-800 rounded-full'>
          //           Unpaid
          //         </div>
          //     );
          //   }
          // },
          {
            Header: 'Currency',
            accessor: 'currency',
            Cell: (row: any) => {
              return (
                <div className="">
                  <span>{row.cell.value || '-'}</span>{' '}
                </div>
              );
            }
          },
          {
            Header: 'Premium',
            accessor: 'outRightPremium',
            Cell: (row: any) => {
              return (
                <div className="min-w-[100px]">
                  <span>{formatCurrencyAmount(row.cell.value, row.row.original.currency || 'GHS')}</span>{' '}
                </div>
              );
            }
          },
          // {
          //   Header: 'Initial Deposit',
          //   accessor: 'initialDeposit',
          //   Cell: (row: any) => {
          //     return (
          //       <div className="min-w-[100px]">
          //         <span> {formatCurrencyAmount(row.cell.value)}</span>
          //       </div>
          //     );
          //   }
          // },
          {
            Header: 'Inception Date',
            accessor: 'inceptionDate',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? moment(row.cell.value).format('DD-MM-YY') : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Expiry Date',
            accessor: 'expiresOn',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? moment(row.cell.value).format('DD-MM-YY') : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Insurer',
            accessor: 'insurerName',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Broker',
            accessor: 'ownerTeamName',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Manager',
            accessor: 'managerName',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? row.cell.value : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Created On',
            accessor: 'createdOn',
            Cell: (row: any) => {
              return (
                <span>
                  {row.cell.value ? moment(row.cell.value).format('DD-MM-YY') : '-'}
                </span>
              );
            }
          },
          {
            Header: 'Action',
            id: 'Action',
            Cell: (row: any) => {
              return (
                <GTableActionColumn actions={getTableRowActions(row.row.original)} />
              )
            }
          },
        ]
      }
    ],
    [countryId]
  );

  const mobileColumns = React.useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Insurer Policy #',
            accessor: 'insurerPolicyNumber',
            Cell: (row: any) => {
              return (
               <RouteLink to={`${getDashboardBase()}/policies/${row?.row?.original.ref}?type=motor`}>
                  {row.cell.value ?? <ShowPendingInfo message="Missing Policy Number" classes=' !w-fit  whitespace-nowrap  h-[24px]  gap-[2px] flex items-center justify-start italic text-gray-400 text-xs rounded-full border border-gray-400 p-2'/>}
                </RouteLink>
              );
            }
          },
          {
            Header: 'Customer',
            accessor: 'firstName',
            Cell: (row: any) => {
              const isCustomerTypeBusiness = row?.row?.original?.customerType === CUSTOMER_TYPE.BUSINESS;
              const fullName = `${row?.row?.original?.firstName} ${row?.row?.original?.lastName}`

              return (
                <RouteLink to={`${getDashboardBase()}/customers/${row.row.original?.customerId}`} showTooltip toolTipMessage={fullName} tooltipDisabled={fullName.length < 25}>
                  {capitalizeSentence(fullName)} {isCustomerTypeBusiness && ` - ${capitalizeSentence(row?.row?.original?.businessName)}`}
                </RouteLink>
              );
            }
          },
          {
            Header: 'Phone #',
            accessor: 'phone',
            Cell: (row: any) => {
              return <span>{getPhoneNumberFromShortCodeFormat(row.cell.value) ?? '-'}</span>;
            }
          },
          {
            Header: 'Status',
            accessor: 'reviewStage',
            Cell: (row: any) => {
              return (
                <PolicyStatus
                  status={getPolicyReviewStatus(row.cell.value)}
                  firstSuccessfulPayment={new Policy(
                    row?.row?.original
                  )?.isInitialPaymentReceived()}
                  classes="px-2 "
                />
              );
            }
          },
          {
            Header: 'Action',
            id: 'Action',
            Cell: (row: any) => {
              return (
                <div className="sticky right-0 bg-white dark:bg-darkBg px-2 shadow-[ -2px 0px 5px 0px rgba(0,0,0,0.1) dark:shadow-[ -2px 0px 5px 0px rgba(255,255,255,0.1)]">
                  <GTableActionColumn actions={getTableRowActions(row.row.original)} />
                </div>
              );
            }
          }
        ]
      }
    ],
    []
  );

  const handlePageChange = (page: number) => {

    getOrUpdateQueriesFromUrl(page, searchParams, tableFilters, queriesList, queriesName)
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("type", "motor");
    updatedParams.set("page", page.toString());
    setSearchParams(updatedParams);
  };

  const getOtherActions = () => {
    let actions = [
      {
        label: 'Import data',
        icon: <FileDown className="h-4 w-4" />,
        callback: () => navigate(`${getDashboardBase()}/policies/import-policies`),
      }
    ];


    // if (user.isInsurer() || user.isInternalAdmin() || user.isBroker()) {
    //   actions.push({
    //     label: 'Export policies',
    //     icon: <FileUp className="h-4 w-4" />,
    //     callback: () => (branchStaffs || admins) && showAdminDownloadAllPoliciesModal(user.isSupervisor() ? branchStaffs : admins)
    //   });
    // }

    return actions;
  };

  const getBannerActions = () => {
    let actions = [
      {
        label: 'Create a new policy',
        icon: <FilePlus className="h-4 w-4" />,
        callback: () => {
           updateModalStates({
                show: true,
                size: '4xl',
                children: <QuoteWidgetCalculator onclose={closeModal}/>,
                static: true,
                title: screenWidth <= 550 ? 'Motor Insurance Calculator' : 'Motor Insurance Premium Calculator',
              });
        },
      },
      {
        label: 'Add an existing policy',
        icon: <FileInput className="h-4 w-4" />,
        callback: () => navigate(`${getDashboardBase()}/policies/auto-policy/add-issued-motor-policy`)
      },
      {
        label: 'Import existing policies in bulk',
        icon: <Upload className="h-4 w-4" />,
        callback: () => navigate(`${getDashboardBase()}/policies/import-policies`)
      },
    ];

    return actions;
  };

  const getPolicyTable = () => {
    return (
      <>

        <div>
          <GTable
            selectionChanged={(selectedObjects: Policy[], selectedIndexes: number[]) => {
              const policyIdList = selectedObjects.map((policy) => policy.ref);
              setSelectedPolicies(policyIdList);
              setSelectedPoliciesIndexes(selectedIndexes);
            }}
            columns={screenWidth <= 550 ? mobileColumns : columns}
            data={policies ?? []}
            isRowLinked={false}
            tableType="motor policies"
            onSearch={(searchString: string) => setSearchString(searchString)}
            searchPlaceholder={'Search by name, policy number or registration number...'}
            paginationData={pagination}
            onPageChange={handlePageChange}
            showPerPage={showPerPage}
            onShowPerPageChange={(page: number) => setShowPerPage(page)}
            networkError={networkError}
            loading={isPoliciesLoading}
            tableContainerId="tableId"
            stickyHeader
            actionElement={
              getOtherActions().length > 0 && (
                <PopOnMe actions={getOtherActions()}>
                  <div className="cursor-pointer">
                    <EllipsisVerticalIcon className="h-6 w-6 " />
                  </div>
                </PopOnMe>
              )
            }
            selectedFilters={tableFilters}
            onRemoveFilter={(filter: ITableFilterItem, index: number) => {
              onRemoveFilter(filter, index, tableFilters, setFilters, setSearchParams, queriesList)
            }}
            exportFilteredData={exportPoliciesFromFilters}
            showFilter={
              <TableFilter
                openFilter={openFilter}
                onFilterChange={(filterState: boolean) => setOpenFilter(filterState)}
                content={
                  <TableFilterForm
                    filters={tableFilters}
                    getValues={(filters: ITableFilterItem[]) => {
                      updateQueriesList(filters, queriesList)
                      setFilters(filters);
                      setSearchParams(queriesList)
                      setOpenFilter(false);
                    }}
                    onResetFilters={() => setFilters(getDefaultFilters())}
                  />
                }
              />
            }

          />
        </div>

      </>
    );
  };

  const getHomePolicyTable = () => {
    return (
      <div>
        {homePolicies && (
          <div>
            <GTable
              selectionChanged={() => { }}
              columns={homeColumns}
              data={homePolicies}
              tableType="home policies"
              paginationData={homePoliciesPaginationData}
              onPageChange={handlePageChange}
              showPerPage={showPerPage}
              onShowPerPageChange={(page: number) => setShowPerPage(page)}
              columnClasses="first:min-w-[210px] max-w-[200px]"
              showSearch={false}
              tableContainerId="tableId"
            />
          </div>
        )}
      </div>
    );
  };

  useQuery({ queryKey: ['getAllBrollyInsurers', countryId], queryFn: getAllBrollyInsurers })

  const { data, isLoading: isPoliciesLoading, isFetching } = useQuery({
    queryKey: [
      "getPolicies",
      activeTab,
      currentPage,
      showPerPage,
      countryId,
      searchParam,
      startFrom,
      startTo,
      _filter,
      expiredTo,
      expiredFrom,
      createFrom,
      createTo,
      protectionType,
      vehicleUsage,
      leadSource,
      managerId,
      brokerId,
      insurerId,
      branchId,
    ],
    queryFn: getPolicies,
    staleTime: 1000 * 10,
    placeholderData: (prev) => prev,
    gcTime: 1000 * 60 * 30 * 5,
    refetchOnWindowFocus: false,
    select: (response) => {

      return {
        policies: response.data.content ?? [],
        totalRecords: response.totalRecords,
        pagination: {
          per_page: response.data.size,
          total: response.data.totalElements,
          totalPages: response.data.totalPages,
          from: response.data.pageable?.offset + 1,
          to: response?.data?.totalElements > response?.data?.pageable?.offset + showPerPage
            ? response?.data?.pageable?.offset + showPerPage : response?.data?.totalElements,
        },
      };
    },
  });

  const pagination = data?.pagination;
  const policies = React.useMemo(() => {
    return data?.policies?.map((p: any) => new PolicySummary(p));
  }, [data?.policies]);

  // useQuery({
  //   queryKey: [
  //     'getFleetPolicies',
  //     activeTab,
  //     currentPage,
  //     showPerPage,
  //     searchParam,
  //     startFrom,
  //     startTo,
  //     _filter,
  //     expiredTo,
  //     expiredFrom,
  //     createFrom,
  //     createTo,
  //     protectionType,
  //     vehicleUsage,
  //     leadSource,
  //     managerId,
  //     park
  //   ],
  //   queryFn: getFleetPolicies
  // });

  useQuery({ queryKey: ['getAllAdmins'], queryFn: getAllAdmins });
  useQuery({ queryKey: ['getAllBranchStaffs'], queryFn: getAllBranchStaffs });
  useQuery({
    queryKey: ['fetchAllCompaniesByType'],
    queryFn: async () => {
      const response = await fetchAllCompaniesByType(COMPANY_TYPES.BROKER);
      const _brokers = response?.map((broker: Pick<Company, 'id' | 'name'>) => ({
        name: broker.name,
        value: Number(broker.id)
      }));
      setBrokers(_brokers);
      return response;
    }
  })

  return (
    <>
    { policiesCount?.motorPolicies === 0 && !isFetching && user.isBroker() && <div className='py-4'>
      <Banner
        // key={index}
        variant={'info'}
        message={"It looks like you haven't added any policy yet. To begin managing your portfolio, you can:"}
        position="top"
        isSticky={true}
        dismissible={true}
        onDismiss={() => {}}
        actions={
          getBannerActions().length > 0 && (
          <PopOnMe actions={getBannerActions()}>
            <div>
              <Button
                  label={'Actions'}
                  size="sm"
                  bgColor='primary'
                  appendIcon={<ChevronDown size={14} />
                  }
                  className='!h-7 !text-xs'
                />
            </div>
          </PopOnMe>
        )
        }
      />
    </div>}
    <Page title="Policies">
      <div ref={pageRef} className="bg-white dark:bg-darkBg p-5 w-full rounded-lg shadow-md dark:shadow-darkBg-shadow" >
        <div className="flex flex-col md:flex-row justify-between md:items-center">
          <div>
            <div className="inline-flex items-center gap-2 mb-2 dark:text-darkBg-mainText">
              <div className="h-8 w-2 bg-gradient-to-b from-yellow-500 to-yellow-700 rounded"></div>
              <h2 className="font-semibold text-3xl">
                {policyType == 'home' ? 'Home Insurance Policies' : 'Motor Insurance Policies'}
              </h2>
            </div>
            <div className='flex items-center justify-center'>

              {policyType == 'home' ? (
                <p className="text-sm text-slate-400">
                  View a list of individual home policies and associated details.
                </p>
              ) : (
                <p className="text-sm text-slate-400">
                  View a list of individual and fleet motor policies and associated details.
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="mt-6">
          {policyType == 'home' ? getHomePolicyTable() : getPolicyTable()}
        </div>


      </div>
      <DownloadHookModal />
      <PolicyModalComponent />
      <ModalComponent />
    </Page>
    </>
  );
}

export default Policies;
